var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBtnSend = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 38 38"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 38,
  height: 38,
  fill: "#111",
  rx: 19
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M19.825 11.5v16h-2v-16z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "m18.936 10.5 7.387 7.368-1.274 1.164-6.113-6.188-6.337 5.868-1.274-1.165z",
  clipRule: "evenodd"
})));
export default SvgBtnSend;